import type { SortType } from "@/features/catalog/stores/catalogStore";

export const CATALOG_SORT_OPTIONS: ReadonlyArray<{
  label: string;
  sort: SortType;
}> = [
  { sort: "bump", label: "更新順" },
  { sort: "new", label: "新順" },
  { sort: "old", label: "古順" },
  { sort: "replies", label: "多順" },
  { sort: "momentum", label: "勢順" },
  { sort: "soudane", label: "そ順" },
];
